"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Loader_1 = require("./Loader");
exports.default = Loader_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/Loader/index.js
// module id = 379
// module chunks = 8